import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { startTrainingProgram, fetchTrainingWeeksDays, fetchExercisesForDayAndWeek, 
  moveExerciseUp, moveExerciseDown, updateSets, clearMessage, clearHistory, reset_programs_options, reset_weeks_options, 
  addSet, removeSet, deleteExerciseFromUserProgram, pinExerciseNote, getExerciseHistory } from '../../../redux/slices/customer/trainingSlice';
import { fetchExerciseMin } from '../../../redux/slices/optionsSlice';
import Layout from '../Layout';
import { Link } from 'react-router-dom';
import Back from '../../../components/common/Back';
import iconCheck from '../../../images/icon-check-recipe-ing.svg';
import iconSantp from '../../../images/icon-santp.svg';
import iconRptp from '../../../images/icon-rptp.svg';
import iconCalendar from '../../../images/icon-calendar.svg';
import iconVerticalDots from '../../../images/icon-vertical-dots.svg';
import iconPlusSymbol from '../../../images/icon-plus-symbol.svg';
import iconMinus from '../../../images/icon-minus.svg';
import iconDownArrowWeek from '../../../images/icon-down-arrow-week.png';
import iconUpArrowsFat from '../../../images/icon-up-arrows-fat.svg';
import iconReplace from '../../../images/icon-replace.svg';
import iconYoutube from '../../../images/icon-youtube.svg';
import iconInfo from '../../../images/info.svg';
import { ReactComponent as IconPushPin } from '../../../images/icon-push-pin.svg';
import { ReactComponent as IconPushPinGreen } from '../../../images/icon-push-pin-red.svg';
import { verifyAccessToken, loginAsAdminFunc, updateWeekAndDay } from '../../../redux/slices/protectSlice';
import iconEditNote from '../../../images/icon-edit-note.svg';
import iconDelete from '../../../images/icons8-delete.svg';
import VideoModal from './VideoModal';
import ReplaceExerciseModal from './ReplaceExerciseModal';
import HistoryModal from './HistoryModal';
import InfoModal from './InfoModal';
import WeeksModal from './WeeksModal';
import ProgramsModal from './ProgramsModal';
import NotesModal from './NotesModal';
import AddExerciseModal from "./AddExerciseModal";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const TrainingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { daysWeeks, exercises_for_day, program_details, no_program_msg, exercise_history} = useSelector((state) => state.customer_training);
  const { latest_week, latest_day  } = useSelector((state) => state.protect);
  const exercises_min = useSelector((state) => state.app_options.exercises_min);
  const [activeDay, setactiveDay] = useState(latest_day);
  const [currentNote, setCurrentNote] = useState('');
  const [activeWeek, setactiveWeek] = useState(latest_week);
  const [calendarActive, setcalendarActive] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [weekDetails, setWeekDetails] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [localExercises, setLocalExercises] = useState(exercises_for_day);
  const [programDetails, setProgramDetails] = useState(program_details);

  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [currentTrainingName, setCurrentTrainingName] = useState('');

  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [exerciseHistory, setExerciseHistory] = useState([]);
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [isWeeksModalOpen, setIsWeeksModalOpen] = useState(false);
  const [isProgramsModalOpen, setIsProgramsModalOpen] = useState(false); 
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false); 
  const [isExerciseModalOpen, setIsExerciseModalOpen] = useState(false);  

  useEffect(() => {  	
    setactiveWeek(latest_week);
    setactiveDay(latest_day);
    dispatch(clearMessage()); 
    dispatch(reset_weeks_options()); 
    dispatch(reset_programs_options());
    dispatch(fetchTrainingWeeksDays());
  }, []);

  useEffect(() => {   
    setactiveWeek(latest_week);
    setactiveDay(latest_day);
  }, [latest_week, latest_day]);

  

  useEffect(() => {  
    if (exercise_history == '' ) {
     if(JSON.stringify(exercise_history) == '[]') {
      setIsHistoryModalOpen(true);
     } else {
      setIsHistoryModalOpen(false);
     }      
    } else {
      setIsHistoryModalOpen(true);
    }   
  }, [exercise_history]);

  const closeHistoryModal = () => {
    setIsHistoryModalOpen(false);
    dispatch(clearHistory());
  }  

  const authenticated_user = useSelector((state) => state.apiResponses);
  React.useEffect(() => {
   if(authenticated_user.hasOwnProperty('authenticated_user')) {
    if(authenticated_user.authenticated_user.hasOwnProperty('authenticated_user')) {
      if(authenticated_user.authenticated_user.authenticated_user.account_type == 'client' && authenticated_user.authenticated_user.authenticated_user.override_disable_training_setting != 'YES') {
        navigate('/meal-plan');
      }
    }
   }
  }, [authenticated_user]);

  const handleInputChange = (exerciseId, setIndex, type, value) => {
    const updatedExercises = [];
    for (let i = 0; i < localExercises.length; i++) {
      const exercise = localExercises[i];
      if (exercise.id === exerciseId) {
        const updatedExercise = { ...exercise };
        const updatedSets = [];
        for (let j = 0; j < exercise.sets_object.length; j++) {
          const set = exercise.sets_object[j];
          if (j === setIndex) {
            const updatedSet = { ...set, [type]: value };
            updatedSets.push(updatedSet);
          } else {
            updatedSets.push(set);
          }
        }
        updatedExercise.sets_object = updatedSets;
        updatedExercises.push(updatedExercise);
      } else {
        updatedExercises.push(exercise);
      }
    }
    setLocalExercises(updatedExercises);
  };

  const fetchHistory = (exercise_id, training_name) => {
    setCurrentTrainingName(training_name);
    dispatch(getExerciseHistory({id:exercise_id, training_name:training_name}));
    
  }

  const handleInputChangeDistance = (exerciseId, setIndex, type, value) => {
    const updatedExercises = [];
    for (let i = 0; i < localExercises.length; i++) {
      const exercise = localExercises[i];
      if (exercise.id === exerciseId) {
        const updatedExercise = { ...exercise };
        const updatedSets = [];
        for (let j = 0; j < exercise.distance_object.length; j++) {
          const set = exercise.distance_object[j];
          if (j === setIndex) {
            const updatedSet = { ...set, [type]: value };
            updatedSets.push(updatedSet);
          } else {
            updatedSets.push(set);
          }
        }
        updatedExercise.distance_object = updatedSets;
        updatedExercises.push(updatedExercise);
      } else {
        updatedExercises.push(exercise);
      }
    }
    setLocalExercises(updatedExercises);
  };

  useEffect(() => {  	
    var p = {'week_number':activeWeek,'day_number':activeDay}
    setTimeout(() => {
  dispatch(fetchExercisesForDayAndWeek(p));
}, 50);

    dispatch(fetchExerciseMin());
  }, [activeDay, activeWeek]);

  useEffect(() => { setWeekDetails(daysWeeks); }, [daysWeeks]);

  useEffect(() => {  document.querySelectorAll('.to_disable').forEach(el => {
          el.classList.remove('disabled_class');
     });    setLocalExercises(exercises_for_day); }, [exercises_for_day]);

  useEffect(() => { 
    if (selectedProgram && selectedProgram != '') { 
      handleProgramSelect(selectedProgram); 
      closeProgramsModal(); 
    } 
  }, [selectedProgram]);

  const handleDeleteExerciseConfirm = (id) => {
        confirmAlert({
          title: 'Confirm Deletion',
          message: 'Are you sure you want to delete this exercise?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => handleDeleteExercise(id)
            },
            {
              label: 'No',
              onClick: () => {}
            }
          ]
        });    
    };


  const handleDeleteExercise = (id) => {
    var p = {'id':id, 'week_number':activeWeek, 'day_number':activeDay};
    dispatch(deleteExerciseFromUserProgram(p));
  }  

 

  const getAdjacentExercises = (data, id) => {
    const exercises = [];
    sortedGroups.forEach(letter => {
        groupedByLetter[letter].slice().sort((a, b) => a.sequence.localeCompare(b.sequence)).forEach(exercise => {
            exercises.push(exercise);
        });
    });

    const currentExerciseIndex = exercises.findIndex(exercise => exercise.id === id);
    if (currentExerciseIndex === -1) {
        return { error: "Exercise with the provided ID not found." };
    }
    const currentExercise = exercises[currentExerciseIndex];
    const previousExercise = exercises[currentExerciseIndex - 1] || null;
    const nextExercise = exercises[currentExerciseIndex + 1] || null;

    return {
        current: {
            id: currentExercise.id,
            sequence: currentExercise.sequence,
        },
        previous: previousExercise
            ? { id: previousExercise.id, sequence: previousExercise.sequence }
            : null,
        next: nextExercise
            ? { id: nextExercise.id, sequence: nextExercise.sequence }
            : null,
    };
};

  const handleMoveUp = (exercise_id, sequence) => {
    const data = {};
    const result = getAdjacentExercises(data, exercise_id);

    if (!result.previous) {
      alert('This exercise is already at top position.');
      return false;
    }

    var replaceable_exercise_id = result.previous.id;
    var replaceable_exercise_sequence = result.previous.sequence;

    var p = {'week_number':activeWeek,'day_number':activeDay, 'exercise_id':exercise_id, 'sequence':sequence, replaceable_exercise_id:replaceable_exercise_id, replaceable_exercise_sequence:replaceable_exercise_sequence};
    dispatch(moveExerciseUp(p));
  }

  const handleMoveDown = (exercise_id, sequence) => {
    const data = {};
    const result = getAdjacentExercises(data, exercise_id);

    if (!result.next) {
      alert('This exercise is already at the bottom position.');
      return false;
    }

    var replaceable_exercise_id = result.next.id;
    var replaceable_exercise_sequence = result.next.sequence;
    var p = {'week_number':activeWeek,'day_number':activeDay, 'exercise_id':exercise_id, 'sequence':sequence, replaceable_exercise_id:replaceable_exercise_id, replaceable_exercise_sequence:replaceable_exercise_sequence};
    dispatch(moveExerciseDown(p));
  }

  const handleProgramSelect = (programId) => {
    setSelectedProgram(programId);

    var payload = {"latest_week":1, "latest_day":1}
    dispatch(updateWeekAndDay(payload));

    var p = {'training_program_id': programId};
    dispatch(startTrainingProgram(p));
  };

  const fetchExerciseByClick = (week_number, day_number) => {
    setactiveWeek(week_number);
    setactiveDay(day_number);
    setcalendarActive(false);
    var p = {'week_number':week_number,'day_number':day_number}
    dispatch(fetchExercisesForDayAndWeek(p));
  }

  const openVideoModal = (url) => {
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsModalOpen(false);
    setVideoUrl('');
  };

  const handleUpdateSets = (id, setIndex, field1, field2) => {
  	const elemId = `btn-${id}-${setIndex}`;
    var field1Value = document.getElementById("field_" + field1 + "_" + activeWeek + "_" + activeDay + "_" + id + "_" + setIndex).value;
    var field2Value = document.getElementById("field_" + field2 + "_" + activeWeek + "_" + activeDay + "_" + id + "_" + setIndex).value;
    const element = document.getElementById(elemId);

    if (!isNaN(field1Value) && !isNaN(field2Value) && field1Value > 0 && field2Value > 0) {
 
        if (element) { 
            element.classList.add("btn-curve-min-green");
            element.classList.remove("btn-curve-min-red");

            setactiveDay(activeDay);
            setactiveWeek(activeWeek);

		  	var p = {"latest_week":activeWeek, "latest_day":activeDay}
		  	dispatch(updateWeekAndDay(p));
        }
    } else { 
        if (element) { 
            element.classList.add("btn-curve-min-red");
            element.classList.remove("btn-curve-min-green");
            
        }
    }
    areAllInputsValid(id);

    dispatch(updateSets({
      set_index: setIndex,
      fields: [
        { type: field1, value: field1Value },
        { type: field2, value: field2Value }
      ],
      id: id,
      week_number: activeWeek,
      day_number: activeDay,
    }));
  };

  const isValidVideoUrl = (url) => {
    if (!url) return false;
    const youtubePattern = /(?:youtube\.com\/(?:shorts\/|(?:v|embed)\/|(?:[^\/]+\/.+\/|.*[?&]v=)|youtu\.be\/)[a-zA-Z0-9_-]{11})/;
    const vimeoPattern = /(?:vimeo\.com\/(?:.*#|.*\/)?([0-9]+))/;
    return youtubePattern.test(url) || vimeoPattern.test(url);
  };

  const openReplaceModal = (exerciseId) => {
    setSelectedExercise(exerciseId);
    setIsModalOpen2(true);
  };

  const closeReplaceModal = () => {
    setIsModalOpen2(false);
    setSelectedExercise(null);
  };

  const openInfoModal = () => {
    setIsInfoModalOpen(true);
  };

  const closeInfoModal = () => {
    setIsInfoModalOpen(false);
  };

  const openWeeksModal = () => {
    setIsWeeksModalOpen(true);
  };

  const closeWeeksModal = () => {
    setIsWeeksModalOpen(false);
    dispatch(reset_programs_options());
    dispatch(reset_weeks_options());
  };

  const openProgramsModal = () => {
    closeWeeksModal();
    setIsProgramsModalOpen(true);
  };

  useEffect(() => { if (selectedWeek && selectedWeek != '') { openProgramsModal(); } }, [selectedWeek]);

  const closeProgramsModal = () => {
    setSelectedWeek(null);
    setIsProgramsModalOpen(false);
  };

    // Handle adding a new set
  const handleAddSet = (exerciseId) => {

    document.querySelectorAll('.to_disable').forEach(el => {
      el.classList.add('disabled_class');
    });
    

    const updatedExercises = localExercises.map((exercise, index) => {
      if (exercise.id === exerciseId) {       

        if (exercise.sets_object && exercise.sets_object != 'null' && exercise.sets_object != null ) {
          var newIndex = exercise.sets_object.length+1;   
        } else {
          var newIndex = 1;
        }

        const newSet = { set:newIndex, weight: 0, reps: 0 };  // Default new set values
        return { ...exercise, sets_object: [...exercise.sets_object, newSet] };
      }
      return exercise;
    });
    setLocalExercises(updatedExercises);

    var p = {'id':exerciseId, 'week_number':activeWeek, 'day_number':activeDay};
    areAllInputsValid(exerciseId);
    dispatch(addSet(p));

    const groupedByLetter = {};

// Group exercises by their first character
Object.keys(groupedExercises).forEach((sequence) => {
  const letter = sequence[0];  
  if (!groupedByLetter[letter]) {
    groupedByLetter[letter] = [];
  }  
  groupedByLetter[letter].push(...groupedExercises[sequence]);
});

const sortedGroups = Object.keys(groupedByLetter).sort();

  };

  // Handle removing a set
  const handleRemoveSet = (exerciseId, setIndex) => {

    document.querySelectorAll('.to_disable').forEach(el => {
      el.classList.add('disabled_class');
    });

    const updatedExercises = localExercises.map(exercise => {
      if (exercise.id === exerciseId) {

        if (exercise.sets_object && exercise.sets_object != 'null' && exercise.sets_object != null ) {
            var newIndex = exercise.sets_object.length-1;
        } else {
            var newIndex = 0;
        }
        const updatedSets = exercise.sets_object.filter((_, index) => index !== newIndex);
        areAllInputsValid(exerciseId);
        return { ...exercise, sets_object: updatedSets };
      }
      return exercise;
    });
    setLocalExercises(updatedExercises);
    var p = {'id':exerciseId, 'week_number':activeWeek, 'day_number':activeDay};
    dispatch(removeSet(p));
  }; 

function areAllInputsValid(exerciseId) {
    const exerciseDiv = document.querySelector(`#exercise_${exerciseId}`);
    const inputs = exerciseDiv.querySelectorAll('input');
    const buttons = exerciseDiv.querySelectorAll(`#exercise_${exerciseId} .update-btn`);
    const checkElement = document.querySelector(`#exercise_check_${exerciseId}`);
    const btnElement = document.querySelector(`#btn${exerciseId}`);
    const areInputsValid = Array.from(inputs).every(input => parseFloat(input.value) > 0);
    const areButtonsValid = Array.from(buttons).every(button => button.classList.contains('btn-curve-min-green'));
    if (checkElement) {
        if (areInputsValid && areButtonsValid) {
            checkElement.style.visibility = 'visible';
            btnElement.classList.add('btn-light-green'); // Add the green class
            btnElement.classList.remove('btn-light-grey'); // Remove the grey class
        } else {
            checkElement.style.visibility = 'hidden';
            btnElement.classList.add('btn-light-grey'); // Add the grey class
            btnElement.classList.remove('btn-light-green'); // Remove the green class
        }
    }
}


  const openNotesModal = () => {
    setIsNotesModalOpen(true);
  };

  const closeNotesModal = () => {
    setIsNotesModalOpen(false);
  };

  const openExerciseModal = () => {
    setIsExerciseModalOpen(true);
  };

  const closeExerciseModal = () => {
    setIsExerciseModalOpen(false);
  };

  const handleNoteUpdate = (note, id) => {
    setSelectedExercise(id);
    setCurrentNote(note);
    openNotesModal();
  }

  const pinNote = (id) => {
    var p = {'id':id, 'week_number':activeWeek, 'day_number':activeDay};
    dispatch(pinExerciseNote(p));
  }  


const groupedExercises = localExercises.reduce((acc, exercise) => {
  if (!acc[exercise.sequence]) {
    acc[exercise.sequence] = [];
  }
  acc[exercise.sequence].push(exercise);
  return acc;
}, {});

const groupedByLetter = {};

Object.keys(groupedExercises).forEach((sequence) => {
  const letter = sequence[0];
  
  if (!groupedByLetter[letter]) {
    groupedByLetter[letter] = [];
  }
  
  groupedByLetter[letter].push(...groupedExercises[sequence]);
});

const sortedGroups = Object.keys(groupedByLetter).sort(); 







  return (
    <Layout>
      <div className="container-xxl main">
        <header className="main-head flex justify-between align-center">
          <h1 className="greet-user-text">Training</h1>
          <div className="ms-auto">
              <Back />
          </div>
        </header>
        <div className="row mx-0 p-3 g-3 p-md-4 nav-users-tab" style={{backgroundColor:'white'}}>        
          <div className="col-12">
            <div className="btns-training-wrap">              
              <div  onClick={()=>openWeeksModal()} >
                <button className="btn-tp" >
                  <img src={iconSantp} alt="Start a New Training Program" />
                  <span>Start a New Training Program</span>
                </button>
              </div>
              <div>
                <Link to="/previous-training-programs" className="btn-tp">
                  <img src={iconRptp} alt="Restart Previous Training Program" />
                  <span>Restart Previous Training Program</span>
                </Link>
              </div>
            </div>
          </div> 
 
          <div className="col-md-7">
            <div className="card-week">
              <div className="card-week-header position-relative">

            {no_program_msg == '' && (
              <img src={iconInfo} style={{position:'absolute', left:'10px', maxHeight:'25px'}} onClick={() => openInfoModal()} />
            )}
                
                <h1>Week {activeWeek}</h1>
                <ul className="ul-week-links">
                  <li>
                    <a className="btn-day-one" style={{ display:'none', background:activeDay &&  weekDetails.some(week => week.days.some(day => day.day === activeDay && day.done_status)) ? '#0FB80B':'#b8b7b4'}}>
                      Day {activeDay}
                      {activeDay && weekDetails.some(week => week.days.some(day => day.day === activeDay && day.done_status)) && 
                        <img src={iconCheck} alt="Check Icon" />
                      }
                    </a>

                    <a className="btn-day-one" 
                        style={{ 
                          background: activeDay && weekDetails
                            .find(week => week.week === activeWeek) // Only check the active week
                            ?.days.some(day => day.day === activeDay && day.done_status) 
                            ? '#0FB80B' : '#b8b7b4'
                        }}
                      >
                        Day {activeDay}
                        {activeDay && weekDetails
                          .find(week => week.week === activeWeek)
                          ?.days.some(day => day.day === activeDay && day.done_status) && 
                          <img src={iconCheck} alt="Check Icon" />
                        }
                    </a>
                  </li>

                  { no_program_msg == '' && (
                    <>
                  <li>
                    <button className="btn-calendar-week" onClick={()=>setcalendarActive(!calendarActive)}>
                      <img src={iconCalendar} alt="Calendar Icon" />
                    </button>
                  </li>
                  <li>
                    <button type="button" className="btn-vertical-dots" data-bs-toggle="dropdown" aria-expanded="false">
                      <img src={iconVerticalDots} alt="Vertical Dots" />
                    </button>
                    <ul className="dropdown-menu dropdown-menu-weeks dropdown-menu-end" >
                      <li><a className="dropdown-item" onClick={openExerciseModal} ><img src={iconPlusSymbol} alt="Edit Icon" />Add Exercise</a></li>
                     </ul>
                  </li>
                  </>
                  )}
                </ul>
              </div>               
              
              {calendarActive && (
                <div className="card-week-body">                
                  <div className="scroll-container">
                    <ul className="ul-week-btns-wrap">
                      {weekDetails && weekDetails.map((week, index) => (
                        <li key={index}>
                          <ul className="ul-week-col-child">
                            <li>
                              <a className={`btn-gray-curve radius-top-bottom ${ (week.done_status) ? 'active' : ''}`}>
                                Week {week.week}
                              </a>
                            </li>
                            {week.days.map((day, dayIndex) => (
                              <li key={dayIndex}>
                                <Link 
                                  onClick={() => fetchExerciseByClick(week.week, day.day)} 
                                  className={`btn-gray-curve  radius-right-left ${ (day.done_status) ? 'btn-light-green-curve active' : ''}`}
                                >
                                  {`Day ${day.day}`}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>                   
                </div>
             )}

            {no_program_msg && no_program_msg.trim() !== '' && (
              <h5 style={{ color: '#de2c2f', padding: '20px', textAlign: 'center' }}>
                {no_program_msg}
              </h5>
            )}

            </div>
            
          </div>
  
 
    {sortedGroups && sortedGroups.map((letter, index) => (
      <div key={letter}>     
        <div className="row">
          {groupedByLetter[letter].slice().sort((a, b) => a.sequence.localeCompare(b.sequence)).map((exercise, exerciseIndex) => (
            <div className="col-md-7" key={exercise.id} id={`exercise_${exercise.id}`} style={{marginTop:'15px !important'}}>
              <div className="card-week" style={{backgroundColor:'#f5f5f5'}}>
                <div className="card-header-week" >
                  <div className="card-header-week-wrap">
                    <div className="btn-light-green-wrap">
                      <button className={ exercise.exercise_completed_status ? 'btn-light-green':'btn-light-grey'} id={`btn${exercise.id}`}
                      >
                        {exercise.training_category}
                        <img
                          id={`exercise_check_${exercise.id}`}
                          src={iconCheck}
                          alt="Check Icon"
                          style={{ border: exercise.exercise_completed_status ? 'visible' : 'hidden' }}
                        /> 

                      </button>
                    </div>
                    
                    <h1>{exercise.training_name}</h1>

                    {exercise.sequence && (
                      <span className="sequenceSpan">{exercise.sequence}</span>
                    )}
                    
                    <ul className="ul-week-links ul-week-links-chw">
                      <li>
                        {isValidVideoUrl(exercise.video_url) && (
                          <button className="btn-calendar-week">
                            <img
                              src={iconYoutube}
                              onClick={() => openVideoModal(exercise.video_url)}
                              alt="YouTube Icon"
                            />
                          </button>
                        )}
                      </li>
                      <li>
                        <button
                          type="button"
                          className="btn-vertical-dots"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img src={iconVerticalDots} alt="Vertical Dots" />
                        </button>
                        <ul className="dropdown-menu dropdown-menu-weeks dropdown-menu-end">

                          <li onClick={() => handleAddSet(exercise.id)} className="to_disable">
                            <a className="dropdown-item to_disable">
                              <img src={iconPlusSymbol} alt="Add Icon" />
                              Add Set
                            </a>
                          </li>

                          <li onClick={() => handleRemoveSet(exercise.id, exerciseIndex)} className="to_disable">
                            <a className="dropdown-item to_disable">
                              <img src={iconMinus} alt="Minus Icon" />
                              Remove Set
                            </a>
                          </li>

                          <li className="to_disable">
                            <a
                              className="dropdown-item to_disable"
                              onClick={() => handleMoveUp(exercise.id, exercise.sequence)}
                            >
                              <img src={iconUpArrowsFat} alt="Move Up" / >
                              Move Up
                            </a>
                          </li>

                          <li className="to_disable">
                            <a
                              className="dropdown-item to_disable"
                              onClick={() => handleMoveDown(exercise.id, exercise.sequence)}
                            >
                              <img src={iconDownArrowWeek} alt="Move Down" />
                              Move Down
                            </a>
                          </li>

                          <li className="to_disable">
                            <a
                              className="dropdown-item to_disable"
                              onClick={() => openReplaceModal(exercise.id)}
                            >
                              <img src={iconReplace} alt="Replace Icon" />
                              Replace
                            </a>
                          </li>

                          <li className="to_disable">
                            <a
                              className="dropdown-item to_disable"
                              onClick={() => handleDeleteExerciseConfirm(exercise.id)}
                            >
                              <img style={{height:'13px', width:'13px'}} src={iconDelete} alt="Delete" />
                              Delete
                            </a>
                          </li>  

                        </ul>

                      </li>
                    </ul>


                  </div>
                  <ul className="ul-test-notes">
                    <li>  
                      <img style={{marginTop:'-4px'}} src={iconEditNote} onClick={()=>handleNoteUpdate(exercise.notes, exercise.id)} alt="Edit Note" />                    
                      {exercise.pinned_status == 'yes' ? exercise.pinned_note : exercise.notes}                       
                    </li>
                    <li>
                     <button className="btn-pin" onClick={()=>pinNote(exercise.id)}>
                      {exercise.pinned_status == 'yes' ? <IconPushPinGreen fill="#0FB80B" /> : <IconPushPin fill="#999" />}
                    </button>
                    </li>
                  </ul>

                  {exercise.personal_best !== null && exercise.personal_best !== 0 && exercise.personal_best !== '' && (
                    <p style={{ color: 'green', fontSize: '13px', marginLeft: '15px' }}>
                      Your personal best was: {exercise.personal_best} KG
                    </p>
                  )}

                </div>

                {/* Render sets based on 'WEIGHT-SETS' or 'TIME-DISTANCE' */}
                {exercise.setsweight_or_timedistance === 'WEIGHT-SETS' || exercise.setsweight_or_timedistance === 'Weight and Sets' ||
                exercise.setsweight_or_timedistance === '' ? (
                  <div className="card-body-week">
                   
                    <div className="row mx-0 gx-5">
                      <div className="col-2 border-bottom pb-3">Set</div>
                      <div className="col-3 border-bottom pb-3">Weight</div>
                      <div className="col-3 border-bottom pb-3">Reps</div>
                      <div className="col-2 border-bottom pb-3"><span style={{cursor:'pointer', backgroundColor:'rgb(184, 183, 180)', position:'absolute'}} onClick={() => fetchHistory(exercise.id, exercise.training_name)} className="sequenceSpan">History</span>
</div>
                    </div>
                    {exercise.sets_object &&
                      exercise.sets_object.map((set, setIndex) => (
                        <div className="row mx-0 gx-5" key={setIndex}>
                          <div className="col-2 border-bottom py-3">{set.set}</div>
                          <div className="col-3 border-bottom py-3">
                            

                                 <input
                              type="number"
                              value={set.weight || ''}
                              className="form-control"
                              onChange={(e) =>
                                handleInputChange(
                                  exercise.id,
                                  setIndex,
                                  'weight',
                                  e.target.value
                                )
                              }
                              id={`field_weight_${activeWeek}_${activeDay}_${exercise.id}_${setIndex}`}
                            />
                          </div>
                          <div className="col-3 border-bottom py-3">
                          <input
      type="number"
      value={!set.reps || set.reps == 0 ? '' : set.reps}
      className="form-control reps_field"
      placeholder={exercise.reps}
      onChange={(e) =>
        handleInputChange(
          exercise.id,
          setIndex,
          'reps',
          e.target.value
        )
      }
      id={`field_reps_${activeWeek}_${activeDay}_${exercise.id}_${setIndex}`}
    />


                          </div>
                          <div className="col-2 border-bottom py-3">
                            <button
                              className={
                                set.status === 1 || set.status === true
                                  ? 'btn-curve-min-green update-btn'
                                  : 'btn-curve-min-red update-btn'
                              }
                              id={`btn-${exercise.id}-${setIndex}`}
                              onClick={() =>
                                handleUpdateSets(exercise.id, setIndex, 'weight', 'reps')
                              }
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      ))}
                  </div>
                ) : exercise.setsweight_or_timedistance === 'TIME-DISTANCE' ? (
                  <div className="card-body-week">
                    <div className="row mx-0 gx-5">
                      <div className="col-2 border-bottom pb-3">Sr</div>
                      <div className="col-3 border-bottom pb-3">Time (Min)</div>
                      <div className="col-3 border-bottom pb-3">Distance (Km)</div>
                      <div className="col-2 border-bottom pb-3">Update</div>
                    </div>
                    {exercise.distance_object &&
                      exercise.distance_object.map((set, setIndex) => (
                        <div className="row mx-0 gx-5" key={setIndex}>
                          <div className="col-2 border-bottom py-3">{set.set}</div>
                          <div className="col-3 border-bottom py-3">
                            <input
                              type="number"
                              value={set.distance || ''}
                              className="form-control"
                              onChange={(e) =>
                                handleInputChangeDistance(
                                  exercise.id,
                                  setIndex,
                                  'distance',
                                  e.target.value
                                )
                              }
                              id={`field_distance_${activeWeek}_${activeDay}_${exercise.id}_${setIndex}`}
                            />
                          </div>
                          <div className="col-3 border-bottom py-3">
                            <input
                              type="number"
                              value={set.time || ''}
                              className="form-control"
                              onChange={(e) =>
                                handleInputChangeDistance(
                                  exercise.id,
                                  setIndex,
                                  'time',
                                  e.target.value
                                )
                              }
                              id={`field_time_${activeWeek}_${activeDay}_${exercise.id}_${setIndex}`}
                            />
                          </div>
                          <div className="col-2 border-bottom py-3">
                            <button
                              className={
                                set.status === 1 || set.status === true
                                  ? 'btn-curve-min-green update-btn'
                                  : 'btn-curve-min-red update-btn'
                              }
                              id={`btn-${exercise.id}-${setIndex}`}
                              onClick={() =>
                                handleUpdateSets(exercise.id, setIndex, 'time', 'distance')
                              }
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      ))}
                  </div>
                ) : null}
              </div>
            </div>
          ))}
          {index < Object.keys(groupedByLetter).length - 1 && (
            <hr style={{ borderTop: '4px dotted black', margin: '20px 0' }} />
          )}
        </div>
       
      </div>
    ))}

 

    </div>
  </div>

  <VideoModal isOpen={isModalOpen} videoUrl={videoUrl} onClose={closeVideoModal} />

  <ReplaceExerciseModal isOpen={isModalOpen2} onClose={closeReplaceModal} exercises={exercises_min}  selectedExerciseParent={selectedExercise}
  week_number={activeWeek} day_number={activeDay} />


  <HistoryModal isOpen={isHistoryModalOpen} onClose={closeHistoryModal} exercise_history={exercise_history} currentTrainingName={currentTrainingName} />


  <WeeksModal isOpen={isWeeksModalOpen} onClose={closeWeeksModal} setSelectedWeek={setSelectedWeek}  />

 

   <InfoModal isOpen={isInfoModalOpen} onClose={closeInfoModal} program_details={program_details}  />



  <NotesModal isOpen={isNotesModalOpen} onClose={closeNotesModal} currentNote={currentNote} week_number={activeWeek} day_number={activeDay}
  selectedExerciseParent={selectedExercise} />

  <AddExerciseModal isOpen={isExerciseModalOpen} onClose={closeExerciseModal} week_number={activeWeek} day_number={activeDay} />

  <ProgramsModal isOpen={isProgramsModalOpen} onClose={closeProgramsModal} setSelectedProgram={setSelectedProgram} selectedProgram={selectedProgram} selectedWeek={selectedWeek} />
  </Layout>
  );
};

export default TrainingPage;